module.exports = __webpack_public_path__ + "static/anshul-d27a2aa98c4fcebc0c52f85dfd7cf739.svg";